import "./RiskCompliance.module.css";
import Header from "@/reusable_sections/Header";
import Riskcompliancehero from "./sections/Riskcompliancehero";
import Compliance from "./sections/Compliance";
import Footer from "@/reusable_sections/Footer";
export default function RiskCompliancePage() {
  return <div>
      <Header />
      <Riskcompliancehero />
      <Compliance />
      <Footer />
    </div>;
}